import { Button } from 'rsuite';
import React from 'react';
import { FormModal } from '../../common/FormModal';
import PartnerModalContent from './PartnerModalContent';

type Props = {
  modalPartnerId: string;
  modalPartnerName: string;
  modalPartnerNameEn: string;
  modalPartnerNameDe: string;
  modalPartnerDescription: string;
  modalPartnerDescriptionEn: string;
  modalPartnerDescriptionDe: string;
  modalPartnerDescriptionLong: string;
  modalPartnerDescriptionLongEn: string;
  modalPartnerDescriptionLongDe: string;
  modalPartnerAnnotation: string;
  modalPartnerAnnotationEn: string;
  modalPartnerAnnotationDe: string;
  modalPartnerLink: string;
  handleModalClose: () => void;
  setModalPartnerName: (value: string) => void;
  setModalPartnerNameEn: (value: string) => void;
  setModalPartnerNameDe: (value: string) => void;
  setModalPartnerDescription: (value: string) => void;
  setModalPartnerDescriptionEn: (value: string) => void;
  setModalPartnerDescriptionDe: (value: string) => void;
  setModalPartnerDescriptionLong: (value: string) => void;
  setModalPartnerDescriptionLongEn: (value: string) => void;
  setModalPartnerDescriptionLongDe: (value: string) => void;
  setModalPartnerAnnotation: (value: string) => void;
  setModalPartnerAnnotationEn: (value: string) => void;
  setModalPartnerAnnotationDe: (value: string) => void;
  setModalPartnerLink: (value: string) => void;
  submit: () => Promise<void>;
  errorSummary?: string[];
};

export default function EditUserModal({
  modalPartnerId,
  modalPartnerName,
  modalPartnerNameEn,
  modalPartnerNameDe,
  modalPartnerDescription,
  modalPartnerDescriptionEn,
  modalPartnerDescriptionDe,
  modalPartnerDescriptionLong,
  modalPartnerDescriptionLongEn,
  modalPartnerDescriptionLongDe,
  modalPartnerAnnotation,
  modalPartnerAnnotationEn,
  modalPartnerAnnotationDe,
  modalPartnerLink,
  handleModalClose,
  setModalPartnerName,
  setModalPartnerNameEn,
  setModalPartnerNameDe,
  setModalPartnerDescription,
  setModalPartnerDescriptionEn,
  setModalPartnerDescriptionDe,
  setModalPartnerDescriptionLong,
  setModalPartnerDescriptionLongEn,
  setModalPartnerDescriptionLongDe,
  setModalPartnerAnnotation,
  setModalPartnerAnnotationEn,
  setModalPartnerAnnotationDe,
  setModalPartnerLink,
  submit,
  errorSummary = [],
}: Props) {
  return (
    <FormModal
      open={modalPartnerId.length > 0}
      onClose={handleModalClose}
      title="Редагувати партнера"
      errorSummary={errorSummary}
      footer={
        <>
          <Button onClick={submit} appearance="primary">
            Зберегти
          </Button>
          <Button onClick={handleModalClose} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      <PartnerModalContent
        modalPartnerName={modalPartnerName}
        modalPartnerNameEn={modalPartnerNameEn}
        modalPartnerNameDe={modalPartnerNameDe}
        modalPartnerDescription={modalPartnerDescription}
        modalPartnerDescriptionEn={modalPartnerDescriptionEn}
        modalPartnerDescriptionDe={modalPartnerDescriptionDe}
        modalPartnerDescriptionLong={modalPartnerDescriptionLong}
        modalPartnerDescriptionLongEn={modalPartnerDescriptionLongEn}
        modalPartnerDescriptionLongDe={modalPartnerDescriptionLongDe}
        modalPartnerAnnotation={modalPartnerAnnotation}
        modalPartnerAnnotationEn={modalPartnerAnnotationEn}
        modalPartnerAnnotationDe={modalPartnerAnnotationDe}
        modalPartnerLink={modalPartnerLink}
        setModalPartnerName={setModalPartnerName}
        setModalPartnerNameEn={setModalPartnerNameEn}
        setModalPartnerNameDe={setModalPartnerNameDe}
        setModalPartnerDescription={setModalPartnerDescription}
        setModalPartnerDescriptionEn={setModalPartnerDescriptionEn}
        setModalPartnerDescriptionDe={setModalPartnerDescriptionDe}
        setModalPartnerDescriptionLong={setModalPartnerDescriptionLong}
        setModalPartnerDescriptionLongEn={setModalPartnerDescriptionLongEn}
        setModalPartnerDescriptionLongDe={setModalPartnerDescriptionLongDe}
        setModalPartnerAnnotation={setModalPartnerAnnotation}
        setModalPartnerAnnotationEn={setModalPartnerAnnotationEn}
        setModalPartnerAnnotationDe={setModalPartnerAnnotationDe}
        setModalPartnerLink={setModalPartnerLink}
      />
    </FormModal>
  );
}
